<template>
  <div>
    <div class="head-img">
      <img :src="$getImgUrl('/img/wx-app/cass-title-img.png')" />
    </div>
    <div class="select-box">
      <img
        :src="
          isApplication
            ? $getImgUrl('/img/wx-app/cass-application1.png')
            : $getImgUrl('/img/wx-app/cass-application.png')
        "
      />
      <!-- <img
        @click="isApplication = false"
        :src="
          isApplication
            ? $getImgUrl('/img/wx-app/cass-logged1.png')
            : $getImgUrl('/img/wx-app/cass-logged.png')
        "
      /> -->
    </div>
    <div v-if="isApplication" class="application-box">
      <div class="app-step-item">
        <img :src="getApplicationStepImg(0, 'title')" alt="" class="app-step-index" />
        <img :src="getApplicationStepImg(0, 'info')" alt="" class="app-step-info" />
        <div class="app-step-item-btn">
          <img
            @click="showImg = true"
            class="btn"
            :src="$getImgUrl('/img/wx-app/cass-application-info-1-btn-download.png')"
          />
          <img
            @click="openUrl('help')"
            class="btn"
            :src="$getImgUrl('/img/wx-app/cass-application-info-1-btn-help.png')"
          />
        </div>
      </div>
      <div class="app-step-item" v-for="item of 3" :key="item">
        <img :src="getApplicationStepImg(item, 'title')" alt="" class="app-step-index" />
        <img :src="getApplicationStepImg(item, 'info')" alt="" class="app-step-info" />
      </div>

      <div class="base-info">
        <div>服务时间：周一至周五9:00-18:00（节假日除外）</div>
        <div>服务热线：400-000-5109</div>
        <div>服务邮箱：bosch-extra@logisticpal.com</div>
      </div>
    </div>

    <!-- <div v-else class="login-box">
      <div class="login">
        <div class="info-item">
          <div class="info-text">开思账号：</div>
          <div class="info-input">
            <input v-model.trim="userInfo.personName" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-text">开思密码：</div>
          <div class="info-input">
            <input type="password" v-model.trim="userInfo.password" />
          </div>
        </div>

        <div class="privacy">
          <van-checkbox v-model="checked" shape="square">阅读并同意</van-checkbox
          ><span class="privacy-style" @click="openUrl('privacy')">隐私协议</span>
        </div>
      </div>
      <div class="create-btn">
        <img :src="$getImgUrl('/img/wx-app/cass-create.png')" @click="handleSubmit" />
      </div>
    </div> -->

    <van-overlay :lock-scroll="false" :show="showImg" @click="show = false">
      <img
        class="close"
        @click="showImg = false"
        src="../../assets/images/new-year/close.png"
      />
      <img class="download-img" :src="imgUrl" alt="" />
    </van-overlay>
  </div>
</template>

<script>
import wxAppApi from '@/api/wx-app'
export default {
  data () {
    return {
      isApplication: true,
      checked: false,
      userInfo: {
        personName: '',
        password: ''
      },
      imgUrl: '',
      showImg: false
    }
  },
  mounted () {
    let smartCode = this.$route.query.smartCode
    let params = {
      smartCode
    }
    wxAppApi.getCassLoginHelpImg(params).then((res) => {
      if (res.data.resultCode === '0') {
        this.imgUrl =
          process.env.VUE_APP_FILE_SERVER + res.data.resultData.fileDTO.fileUri
      }
      console.log(this.imgUrl)
    })
  },
  methods: {
    getApplicationStepImg (item, type) {
      return type === 'title'
        ? this.$getImgUrl(`/img/wx-app/cass-application-item-${item + 1}.png`)
        : this.$getImgUrl(`/img/wx-app/cass-application-info-${item + 1}.png`)
    },
    openUrl (type) {
      if (type === 'help') {
        window.location.href = 'https://mp.weixin.qq.com/s/FECSiadeDYwxbnNLfg9sbQ'
      } else if (type === 'privacy') {
        this.$router.push('/privacy')
      }
    },
    handleSubmit () {
      if (this.checked === false) {
        this.$toast('请阅读并同意隐私条款')
      } else if (this.userInfo.personName === '' || this.userInfo.password === '') {
        this.$toast('请输入账号或密码')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.head-img {
  img {
    width: 100vw;
  }
}
.select-box {
  margin-top: 10px;
  display: flex;
  justify-content: space-evenly;
  img {
    width: 40vw;
    min-width: 120px;
  }
}
.application-box {
  margin-top: 40px;
  .app-step-item {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    .app-step-index {
      width: 80px;
      margin-bottom: 10px;
    }
    .app-step-info {
      width: 93%;
    }
    .app-step-item-btn {
      width: 55%;
      position: absolute;
      top: 110px;
      left: 30px;
      display: flex;
      justify-content: space-between;
      img {
        width: 100px;
      }
    }
  }
  .base-info {
    margin: 0 0 20px 20px;
    font-weight: 600;
    line-height: 25px;
  }
}
.login-box {
  margin-top: 50px;
  text-align: center;
  .login {
    margin-left: 30px;
    text-align: center;
    .info-item {
      height: 35px;
      color: block;
      margin-bottom: 25px;
      display: flex;
      line-height: 35px;
      font-size: 16px;
      .info-text {
        font-weight: 600;
      }
      input {
        height: 40px;
        border-radius: 5px;
        border: 1px solid rgb(214, 214, 214) !important;
      }
    }
    .privacy {
      margin: 40px 0px 15px 60px;
      font-weight: 600;
      font-size: 14px;
      .privacy-style {
        position: relative;
        top: -18px;
        left: -10px;
        color: #32afd8;
        text-decoration-line: underline;
      }
    }
  }
  .create-btn {
    width: 100%;
    text-align: center;
    img {
      width: 250px;
    }
  }
}
.download-img {
  width: 100%;
}
.close {
  float: right;
  width: 30px;
  margin: 10px 0;
}
</style>
